import { observer } from "mobx-react";
import * as React from "react";

import { ListUserGroups } from "../ui/molecules/list-user-groups";
import { ListCommandButtonsUserGroups } from "../ui/organisms/list-command-buttons-user-groups";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageUserGroups extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.userGroups.title")} classic>
                <Section fill>
                    <ListUserGroups
                        listStateId={this.listStateId}
                        showSearchField
                        commandBar={
                            <ListCommandButtonsUserGroups
                                listStateId={this.listStateId}
                                canDelete
                            />
                        }
                    />
                </Section>
            </FusionLayout>
        );
    }
}
